<template>
  <div class="funding-view">
    <iframe
      ref="fundingFrame"
      class="funding-content-frame"
      title="LAFIA funding projects"
      :src="frameSrc"
      :style="{ height: `${frameHeight}px` }"
      scrolling="no"
      @load="syncFrameHeight"
    ></iframe>
  </div>
</template>

<script>
export default {
  data: () => ({
    frameHeight: 320,
    frameSrc: "/funding/content.html?frame=20260729-shared-shell-v1",
  }),

  mounted() {
    window.addEventListener("message", this.handleFrameMessage)
    window.addEventListener("resize", this.syncFrameHeight)
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleFrameMessage)
    window.removeEventListener("resize", this.syncFrameHeight)
  },

  methods: {
    handleFrameMessage(event) {
      const frame = this.$refs.fundingFrame
      if (!frame || event.source !== frame.contentWindow) return
      if (!event.data || event.data.type !== "lafia-funding-content-height") return
      this.setFrameHeight(event.data.height)
    },

    syncFrameHeight() {
      this.$nextTick(() => {
        const frame = this.$refs.fundingFrame
        if (!frame || !frame.contentDocument) return
        const documentElement = frame.contentDocument.documentElement
        const body = frame.contentDocument.body
        if (!documentElement || !body) return
        const footer = body.querySelector(".site-footer")
        const contentHeight = footer
          ? footer.getBoundingClientRect().bottom
          : body.getBoundingClientRect().height
        this.setFrameHeight(contentHeight)
      })
    },

    setFrameHeight(value) {
      const height = Number(value)
      if (!Number.isFinite(height) || height < 320 || height > 20000) return
      this.frameHeight = Math.ceil(height)
    },
  },
}
</script>

<style scoped>
.funding-view {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #fff;
}

.funding-content-frame {
  display: block;
  width: 100%;
  min-height: 320px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  background: #fff;
}
</style>
